import { behaviorOpenFormChannel, channelContentCssPath, channelFormCssPath, channelsTable } from './cssPaths.js';
import { initView, initTable } from '../commonControllers.js';

export const view = initView({
  formCssPath: channelFormCssPath,
  contentCssPath: channelContentCssPath,
  cssPathToElemBehaviorOpenForm: behaviorOpenFormChannel,
});
export const table = initTable({
  tableCssPath: channelsTable,
  prepareColumns: (item) => [item.name, item.type],
});
export * as form from './form.js';
